import { getAuth, signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo } from "firebase/auth";
import { showNotification } from "../../redux/slices/notificationSlice";
import { OauthSignInFucntion } from "../../assets/interfaces/interfaces";
import { v4 as uuidv4 } from "uuid";
import { closeAuthModal } from "../../redux/slices/userSlice";
import { logClickEvent } from "../../analytics";

export const signInWithGoogle: OauthSignInFucntion = async (closeModal, dispatch, navigate) => {
  try {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential && credential.accessToken;
    const user = result.user;

    // Check if this is a new user and log signup event
    const additionalUserInfo = getAdditionalUserInfo(result);
    const isNewUser = additionalUserInfo?.isNewUser;
    if (navigate) {
      const newSessionId = uuidv4();
      navigate(`/chat/${newSessionId}`);
    }

    if (isNewUser) {
      // Log successful signup event for new users
      logClickEvent("sign_up", { method: "google" });
    }

    dispatch(showNotification({ message: "Sign In Successful!", severity: "success", horizontal: "right" }));
    closeModal();
    dispatch(closeAuthModal());
    return { token, user };
  }
  catch (error) {
    console.log({ error });
    dispatch(showNotification({ message: error.message, severity: "error", horizontal: "right" }));
    return { errorCode: error.code, errorMessage: error.message, email: error.email, credential: GoogleAuthProvider.credentialFromError(error) };
  }
};
